@if (settings.showCard || !views.isMobileView()) {
    <card [title]="settings.title" [icon]="'/assets/img/id_icons/50.svg'">
        <div class="settings-card">
            @if (!views.isMobileView()) {
                <settings-menu />
            }
            <ui-view class="settings-content"></ui-view>
        </div>
        <div class="settings-footer">
            {{ subtitle(1648) + ' '  + settings.lastUpdate }}
        </div>
    </card>
}

@if (settings.showMobileMenu && views.isMobileView()) {
    <settings-menu />
}
